import React, { FC, HTMLProps, useEffect } from "react";
import cn from "classnames";
import stl from "./index.module.scss";

interface Props extends HTMLProps<HTMLDivElement> {
  title?: string;
  name: string;
  active?: boolean;
  destroyIfHidden?: boolean;
}
export type TabPaneProps = Props;
const TabPane: FC<Props> = ({
  active,
  children,
  destroyIfHidden,
  ...props
}) => {
  const [visited, setVisited] = React.useState<boolean>(false);

  useEffect(() => {
    if (active) {
      setVisited(true);
    } else if (destroyIfHidden) {
      setVisited(false);
    }
  }, [active, destroyIfHidden]);

  if (!(active || visited) && destroyIfHidden) return null;

  return (
    <div {...props} className={cn(stl.tapPane, { [stl.visible]: active })}>
      {children}
    </div>
  );
};

export default TabPane;
